import { useCallback, useMemo } from 'react';

import { useFormContext, useWatch } from '@kanda-libs/ks-component-ts';

import { FinanceCalculatorLinkModalFormValues } from '../useFinanceCalculatorLinkModal';

export interface FinanceCalculatorAPRSelectHook {
  isSelected: boolean;
  onClick: () => void;
}

export default function useFinanceCalculatorAPRSelect(
  apr: string,
): FinanceCalculatorAPRSelectHook {
  const excludeAprs = useWatch<
    FinanceCalculatorLinkModalFormValues,
    'excludeAprs'
  >({
    name: 'excludeAprs',
  });

  const { setValue } = useFormContext<FinanceCalculatorLinkModalFormValues>();

  const isSelected = useMemo(
    () => !excludeAprs.includes(apr),
    [excludeAprs, apr],
  );

  const onClick = useCallback(() => {
    if (excludeAprs.includes(apr)) {
      const popped = excludeAprs.filter((a) => a !== apr);
      setValue('excludeAprs', popped);
      return;
    }
    const concatted = [...excludeAprs, apr];
    setValue('excludeAprs', concatted);
  }, [apr, excludeAprs, setValue]);

  return {
    isSelected,
    onClick,
  };
}
